import { render, staticRenderFns } from "./SiteUtil.vue?vue&type=template&id=2064609f"
import script from "./SiteUtil.vue?vue&type=script&lang=js"
export * from "./SiteUtil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports